import { render } from "./LoginSection.vue?vue&type=template&id=32761033&ts=true"
import script from "./LoginSection.vue?vue&type=script&lang=ts"
export * from "./LoginSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__